<template>
    <div>
        <div class="logo">
            <img src="../assets/logo.svg"/>
        </div>

        <div class="content">
            <h1>Gastlandschaften Rheinland-Pfalz</h1>
            <h2 class="red">ITB-Quiz</h2>
            <div class="text">
                <p>Bei unserem Quiz bekommen Sie drei Fragen zu Rheinland-Pfalz gestellt.</p>
                <p>Wie gut kennen Sie sich aus?</p>
            </div>
            <router-link class="button" to="quiz">QUIZ STARTEN</router-link>

        </div>
    </div>
</template>

<script>
export default {
    name: 'HelloWorld'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .logo {
        width: 400px;
        padding-top: 80px;
        margin: auto;

        img {
            width: 100%;
            height: auto;
        }
    }

    h1,h2,p {
        color: #002438;
    }

    .red {
        color: #B71E3F;
    }

    h1, h2 {
        font-size: 50px;
        margin: 0;
    }

    .content {
        padding-top: 175px;
    }

    p {
        margin: 0;
    }


    .text {
        margin: 1rem 0 2rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue